import { useState } from "react";
import "./styles/cis.css";
import InternalError from "../components/generales/InternalError";
import { lang } from '../components/generales/traduction'
import PanelCis from "../components/cis-components/PanelCis";
import Monitoreo from "./Monitoreo";
import PanelIndicadores from "../components/monitor-components/PanelIndicadores";
import PanelEventos from "../components/monitor-components/PanelEventos";
import PaneGrupos from "../components/monitor-components/PaneGrupos";
import PaneResets from "../components/monitor-components/PaneResets";
import PanelAfiliationMap from "../components/monitor-components/PanelAfiliationMap";
const MainMonitoreo = ({handleShowPopup,pageSelected, globals,server, dataGlobals,languaje,mode,estados_list,userPermissions,token,estadoSelected,setEstadoSelected}) => {
    const [listSelected, setListSelected] = useState(1);
    const [internalError,setInternalError]=useState(false)
    const hadleChangeList = (e) => {
      setListSelected(e);
    };
    function renderAdminComponent() {
      // console.log(userPermissions)
      try {
          switch (pageSelected) {
              case "monitor-mapa":
                  return <Monitoreo
                        mode={mode}
                        estados_list={estados_list}
                        userPermissions={userPermissions}
                        handleShowPopup={handleShowPopup}
                        server={server}
                        token={token}
                        dataGlobals={globals.data.data}
                        estadoSelected={estadoSelected}
                        setEstadoSelected={setEstadoSelected}
                        languaje={languaje}
                      />
                  ;
                  case "monitor-mapa-afiliation":
                  return <PanelAfiliationMap
                        mode={mode}
                        estados_list={estados_list}
                        userPermissions={userPermissions}
                        handleShowPopup={handleShowPopup}
                        server={server}
                        token={token}
                        dataGlobals={globals.data.data}
                        estadoSelected={estadoSelected}
                        setEstadoSelected={setEstadoSelected}
                        languaje={languaje}
                      />
                  ;
              case "monitor-eventos":
                    return <PanelEventos
                          mode={mode}
                          estados_list={estados_list}
                          userPermissions={userPermissions}
                          handleShowPopup={handleShowPopup}
                          server={server}
                          token={token}
                          dataGlobals={globals.data.data}
                          estadoSelected={estadoSelected}
                          setEstadoSelected={setEstadoSelected}
                          languaje={languaje}
                        />
                    ;
              case "monitor-indicadores":
                  return <PanelIndicadores userPermissions={userPermissions} handleShowPopup={handleShowPopup} languaje={languaje} mode={mode}  server={server}  setInternalError={setInternalError}/>;
              case "monitor-grupos":
                  return <PaneGrupos handleShowPopup={handleShowPopup} languaje={languaje} mode={mode}  server={server}  setInternalError={setInternalError}/>;
              case "monitor-resets":
                  return <PaneResets handleShowPopup={handleShowPopup} languaje={languaje} mode={mode}  server={server}  setInternalError={setInternalError}/>;
                  // case "noti-user":
              //     return <NotifiAdmin languaje={languaje} mode={mode} server={server} setInternalError={setInternalError}/>;
              // case "noti-tec":
              //     return <NotifiTech languaje={languaje} mode={mode} server={server} setInternalError={setInternalError}/>;
              default:
                  return <></>;
          }
      } catch (error) {
          console.error('Error rendering component:', error);
          return <div>{lang[languaje['msgErrorPagina']]}</div>;
      }
  }
    return (
      <div className={"main-cis"+mode}>
         {(internalError)?
              <InternalError/>
              :renderAdminComponent()}
         {/* <PanelExcepciones languaje={languaje} mode={mode} setInternalError={setInternalError} server={server} /> */}
      </div>
    );
};

export default MainMonitoreo;
